import apiClient from './apiClient';

export async function getExecutiveSummary() {
  const res = await apiClient.get('/executive-summary');
  return res.data.data;
}
